import React from 'react';
export function SectionDivider() {
  return <div className="w-full px-6 max-w-2xl mx-auto" data-id="element-221">
      <div className="h-px w-full" style={{
      background: 'linear-gradient(to right, #FF006E, #00F5D4)'
    }} data-id="element-222" />
    </div>;
}